import { createStandaloneToast } from '@chakra-ui/react';
import customTheme from 'styles/theme/customTheme';

export const { ToastContainer, toast } = createStandaloneToast({
  theme: customTheme,
  defaultOptions: {
    position: 'top-right',
    variant: 'solid',
    isClosable: true,
    duration: 5000,
  },
});
